<template>
  <!-- Control de zoom flotante abajo-izquierda: [−] [NN%] [+].
       Conserva los id toolbar-zoomInTools / toolbar-zoomOutTools. El % reinicia la
       vista (fit) al pulsarlo. -->
  <div class="epc-zoom">
    <b-tooltip :label="$t('zoom_out')" position="is-top">
      <div id="toolbar-zoomOutTools" class="epc-zoom-btn"
        @click="$emit('epc-click-zoom-out', false)">
        <b-icon pack="fas" icon="minus" size="is-small"></b-icon>
      </div>
    </b-tooltip>

    <b-tooltip :label="$t('fit_content')" position="is-top">
      <div class="epc-zoom-value" data-action="zoom-reset" @click="$emit('epc-click-fit')">
        {{ Math.round(zoomPercent) }}%
      </div>
    </b-tooltip>

    <b-tooltip :label="$t('zoom_in')" position="is-top">
      <div id="toolbar-zoomInTools" class="epc-zoom-btn"
        @click="$emit('epc-click-zoom-in', true)">
        <b-icon pack="fas" icon="plus" size="is-small"></b-icon>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "WidgetZoom",

  props: {
    zoomPercent: { type: Number, default: 100 },
  },
}
</script>

<style scoped>
.epc-zoom {
  position: absolute;
  left: 12px;
  bottom: 12px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  background-color: #ffffff;
  border: 1px solid #e9e9ef;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.10);
  z-index: 6;
  user-select: none;
}

.epc-zoom-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  color: #495057;
  transition: background-color 0.12s ease, color 0.12s ease;
}

.epc-zoom-btn:hover {
  background-color: #f2f2f7;
  color: #3a6bc8;
}

.epc-zoom-btn:active {
  background-color: #e8eef8;
}

.epc-zoom-value {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 30px;
  padding: 0 6px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  color: #343a40;
  font-variant-numeric: tabular-nums;
  transition: background-color 0.12s ease;
}

.epc-zoom-value:hover {
  background-color: #f2f2f7;
  color: #3a6bc8;
}
</style>
